import { Tab } from "@headlessui/react";
import { BlockWrapper } from "../Preview";
import React from "react";
import { generateCss } from "../../functions/sortableFunctions";
const TabGroup = ({ block, ...props }: any) => {
    return (
        <React.Fragment>
            {

                React.createElement(
                    Tab.Group,
                    {
                        style: {
                            fontFamily: block?.style?.fontFamily
                        },
                        className: generateCss({
                            props: {
                                ...props,
                                block: block
                            },
                        }),
                        id: block.id,
                        ...block.data,
                        as: block.data?.type ? block.data.type : 'div',
                    },
                    block.children.map((value: any, index: any) => {
                        return <BlockWrapper
                            {...props}
                            key={index}
                            block={value}
                        />
                    })
                )
            }
        </React.Fragment>
    )

}
export default TabGroup;